import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { AuthorizationLoadingScreen } from '@/features/session-providers';
import { useAuth } from '@/shared/hooks';

interface ProtectedRouteProps {
    children: ReactNode;
    onAuthComplete?: () => void;
    /** Shown when Firebase resolved and there is no signed-in user (e.g. full login / reset UI from `features/auth`). */
    unauthenticatedFallback: ReactNode;
}

export function ProtectedRoute({ children, onAuthComplete, unauthenticatedFallback }: ProtectedRouteProps) {
    const { user, loading } = useAuth();

    useEffect(() => {
        if (!loading && onAuthComplete) {
            onAuthComplete();
        }
    }, [loading, onAuthComplete]);

    if (loading) {
        return <AuthorizationLoadingScreen />;
    }

    if (!user) {
        return <>{unauthenticatedFallback}</>;
    }

    return <>{children}</>;
}
